import { api } from '../api-client.config';
import { UserType } from 'src/types/domain.types';
import { useQuery } from '@tanstack/react-query';

interface Response {
  contest_users: UserType[];
  future_users: { sso_user_id: string }[];
}

const getUsers = ({ contestId }: { contestId: number }): Promise<Response> =>
  api.get(`/contests/${contestId}/users`);

export const useGetUsersQuery = ({ contestId }: { contestId: number }) => {
  return useQuery({
    queryKey: ['contests', contestId, 'users'],
    queryFn: () => getUsers({ contestId }),
    enabled: !!contestId,
  });
};
